export const useSxStyles = () => {
  return {
    button: {
      float: 'right',
      marginRight: '8px',
    },
    dialogTableHeader: {
      fontSize: '14px',
      textAlign: 'left',
    },
    dialogTableTdBold: {
      fontSize: '14px',
      fontWeight: 'bold',
      width: '180px',
      minWidth: '100px',
    },
    dialogTableTd: {
      fontSize: '14px',
      width: '180px',
      minWidth: '100px',
    },
  };
};
